import OrdersCreateRequestV3 from './models/request/OrdersCreateRequestV3';
import OrdersValidateRequestV3 from './models/request/OrdersValidateRequestV3';
import GetAllOrdersRequestV3 from './models/request/GetAllOrdersRequestV3';
import GetOrderByIdRequestV3 from './models/request/GetOrderByIdRequestV3';
import OrdersAvaliablePaymentTypesRequestV3 from './models/request/OrdersAvaliablePaymentTypesRequestV3';
import GetOrderLongPollRequestV3 from './models/request/GetOrderLongPollRequestV3';

import OrdersAvaliablePaymentTypesResponseV3 from './models/response/OrdersAvaliablePaymentTypesResponseV3';
import OrdersValidateResponseV3 from './models/response/OrdersValidateResponseV3';
import OrdersCreateResponseV3 from './models/response/OrdersCreateResponseV3';
import GetAllOrdersResponseV3 from './models/response/GetAllOrdersResponseV3';
import GetOrderByIdResponseV3 from './models/response/GetOrderByIdResponseV3';
import GetOrderLongPollResponseV3 from './models/response/GetOrderLongPollResponseV3';

import ordersRepositoryV3 from './repository';

export type {
  OrdersValidateRequestV3,
  GetAllOrdersRequestV3,
  GetOrderByIdRequestV3,
  OrdersCreateRequestV3,
  OrdersAvaliablePaymentTypesRequestV3,
  GetOrderLongPollRequestV3,
};

export type {
  OrdersAvaliablePaymentTypesResponseV3,
  OrdersValidateResponseV3,
  OrdersCreateResponseV3,
  GetAllOrdersResponseV3,
  GetOrderByIdResponseV3,
  GetOrderLongPollResponseV3,
};

export default ordersRepositoryV3;
